import { CookieStorage } from "amazon-cognito-identity-js";

export const BrowserStorage = new CookieStorage({
  secure: !!process.env.SECURE || false,
  domain: window?._env_?.DOMAIN || "localhost",
});

export default {
  region: "eu-west-1",
  IdentityPoolId: "",
  UserPoolId: window?._env_?.COGNITO_AUTH_POOL_ID || "eu-west-1_empty",
  ClientId: window?._env_?.COGNITO_AUTH_CLIENT_ID || "empty",
  Storage: BrowserStorage,
};
